import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon, ShieldCheckIcon, LockIcon, DownloadIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusStack() {
  const bonuses = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/pinEmppBCTF8bjTtcyrnP8/BONUS1-LasCreatinasQueSiValenLaPena.png',
    title: 'Las creatinas que sí valen la pena (Lista actualizada 2026)',
    bullets: ['Las marcas que realmente cumplen estándares de pureza'],
    value: '$26.337'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/fzALUhYfrWdRsEpfbs5w9w/BONUS2-LaListaNegra.png',
    title: 'La lista negra de la creatina',
    bullets: ['Marcas con marketing engañoso', 'No cumplen estándares de pureza'],
    value: '$23.565'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/dsC2FhY4EKFwwEdLbBy6WA/BONUS3-ComoElegirUnaCreatina.png',
    title: 'Checklist: Cómo elegir una creatina en 30 segundos',
    bullets: ['Criterios rápidos para elegir correctamente'],
    value: '$12.476'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/8QV9u3xVW6whZe2XFRvRNM/BONUS4-CuantoDineroEstasPerdiendo.png',
    title: 'Cuánto dinero estás perdiendo comprando mal',
    bullets: ['Ejemplos reales de precios inflados', 'Cómo pagar menos por mejor calidad'],
    value: '$26.337'
  }];
  const stackItems = [{
    name: 'Manual Prohibido de la Creatina',
    price: '$40.199'
  }, {
    name: 'Bonus #1',
    price: '$26.337'
  }, {
    name: 'Bonus #2',
    price: '$23.565'
  }, {
    name: 'Bonus #3',
    price: '$12.476'
  }, {
    name: 'Bonus #4',
    price: '$26.337'
  }];
  return <section className="w-full bg-[#0B1C2C] py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* 1. SECTION TITLE */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-3">
          <div className="inline-flex items-center gap-2 bg-[#2F6BFF]/20 border border-[#2F6BFF]/50 rounded-full px-6 py-3 mb-8" data-id="element-4">
            <GiftIcon className="w-5 h-5 text-[#2F6BFF]" data-id="element-5" />
            <span className="text-[#7EC8FF] font-bold tracking-wide uppercase text-sm" data-id="element-6">
              Regalos Exclusivos
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6 leading-tight" data-id="element-7">
            Además del manual, obtienes{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-8">
              4 bonos
            </span>{' '}
            completamente GRATIS
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto font-medium" data-id="element-9">
            Estas guías están diseñadas para ayudarte a evitar errores costosos
            al comprar creatina.
          </p>
        </motion.div>

        {/* 2. INDIVIDUAL BONUS CARDS */}
        <div className="space-y-8 mb-24" data-id="element-10">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#132A44] border border-[#2F6BFF]/30 rounded-2xl overflow-hidden flex flex-col md:flex-row items-center gap-8 p-6 sm:p-8 hover:border-[#2F6BFF]/60 transition-colors relative" data-id="element-11">
              <div className="absolute top-0 right-0 bg-[#FFE600] text-[#0B1C2C] font-black px-6 py-2 rounded-bl-2xl text-sm md:text-base z-10 shadow-lg" data-id="element-12">
                Valor: {bonus.value}
              </div>

              <div className="w-full md:w-1/3 flex-shrink-0 flex justify-center mt-6 md:mt-0" data-id="element-13">
                <img src={bonus.image} alt={bonus.title} className="w-48 md:w-full max-w-[240px] object-contain drop-shadow-2xl" data-id="element-14" />
              </div>

              <div className="w-full md:w-2/3 flex flex-col justify-center" data-id="element-15">
                <div className="text-[#2F6BFF] font-black text-xl mb-2 uppercase tracking-wider" data-id="element-16">
                  Bonus #{bonus.id}
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-[#F2F4F8] mb-6 leading-tight" data-id="element-17">
                  {bonus.title}
                </h3>
                <ul className="space-y-4" data-id="element-18">
                  {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-19">
                      <div className="mt-1 bg-[#2F6BFF]/20 p-1 rounded-full flex-shrink-0" data-id="element-20">
                        <CheckIcon className="w-4 h-4 text-[#7EC8FF]" data-id="element-21" />
                      </div>
                      <span className="text-[#F2F4F8]/90 text-lg" data-id="element-22">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        {/* 3. VALUE STACK SUMMARY */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0E2238] border-2 border-[#2F6BFF]/40 rounded-3xl p-8 sm:p-12 mb-16 shadow-2xl relative overflow-hidden" data-id="element-23">
          <div className="absolute inset-0 bg-gradient-to-br from-[#2F6BFF]/5 to-transparent pointer-events-none" data-id="element-24"></div>

          <h3 className="text-2xl sm:text-3xl font-black text-center text-[#F2F4F8] mb-10" data-id="element-25">
            Si compraras todo esto por separado:
          </h3>

          <div className="space-y-4 max-w-3xl mx-auto mb-10" data-id="element-26">
            {stackItems.map((item, index) => <div key={index} className="flex justify-between items-center border-b border-[#F2F4F8]/10 pb-4" data-id="element-27">
                <span className="text-[#F2F4F8]/80 text-lg sm:text-xl" data-id="element-28">
                  {item.name}
                </span>
                <span className="text-[#F2F4F8] font-bold text-lg sm:text-xl" data-id="element-29">
                  {item.price}
                </span>
              </div>)}
          </div>

          <div className="bg-[#132A44] border border-[#FFE600]/30 rounded-xl p-6 text-center max-w-3xl mx-auto" data-id="element-30">
            <p className="text-[#F2F4F8]/80 text-lg mb-2 uppercase tracking-widest font-semibold" data-id="element-31">
              Valor total del combo
            </p>
            <p className="text-4xl sm:text-5xl font-black text-[#FFE600]" data-id="element-32">
              $128.900
            </p>
          </div>
        </motion.div>

        {/* 4. PRICE DROP MOMENT & 5. PSYCHOLOGICAL LINE & 6. FINAL CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center" data-id="element-33">
          <div className="mb-10 space-y-2" data-id="element-34">
            <p className="text-2xl sm:text-3xl text-red-400/80 font-bold line-through decoration-red-500/50 decoration-4" data-id="element-35">
              No pagarás $128.900
            </p>
            <p className="text-2xl sm:text-3xl text-red-400/80 font-bold line-through decoration-red-500/50 decoration-4" data-id="element-36">
              Ni siquiera $65.000
            </p>
          </div>

          <div className="mb-12" data-id="element-37">
            <p className="text-xl sm:text-2xl text-[#F2F4F8] mb-4 font-medium" data-id="element-38">
              Hoy puedes acceder a todo el combo por solo
            </p>
            <div className="inline-block bg-gradient-to-r from-[#2F6BFF]/20 to-[#7EC8FF]/20 border-2 border-[#2F6BFF] rounded-3xl px-12 py-6 shadow-[0_0_40px_rgba(47,107,255,0.3)]" data-id="element-39">
              <span className="text-6xl sm:text-7xl lg:text-8xl font-black text-[#FFE600] drop-shadow-lg" data-id="element-40">
                $26.300
              </span>
            </div>
          </div>

          <div className="max-w-2xl mx-auto mb-10 bg-[#132A44]/50 border-l-4 border-[#2F6BFF] p-6 rounded-r-xl text-left" data-id="element-41">
            <p className="text-xl text-[#F2F4F8]/90 italic font-medium leading-relaxed" data-id="element-42">
              "Si esta información te ayuda a evitar comprar una sola creatina
              mala, el manual ya se pagó solo."
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-43">
            <CTAButton size="large" className="w-full sm:w-auto text-xl sm:text-2xl py-6 px-10 mb-6" data-id="element-44">
              Quiero acceder al Manual
            </CTAButton>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-[#F2F4F8]/60 text-sm font-medium" data-id="element-45">
              <div className="flex items-center gap-2" data-id="element-46">
                <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-47" />
                <span data-id="element-48">Pago seguro con MercadoPago</span>
              </div>
              <div className="hidden sm:block text-[#F2F4F8]/30" data-id="element-49">•</div>
              <div className="flex items-center gap-2" data-id="element-50">
                <DownloadIcon className="w-5 h-5 text-[#7EC8FF]" data-id="element-51" />
                <span data-id="element-52">Descargás en 2 minutos</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}